export const GET_MY_WALLET = 'GET_MY_WALLET'
export const GET_TRANSACTIONS = 'GET_TRANSACTIONS'
export const DEPOSIT = 'DEPOSIT'
export const LOADING_WALLET = 'LOADING_WALLET'